class CartRemoveButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("click", (event) => {
      event.preventDefault();
      this.closest("cart-items").updateQuantity(this.closest('.cart-item').dataset.key, 0);
    });
  }
}

customElements.define("cart-remove-button", CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();

    this.lineItemStatusElement = document.getElementById(
      "shopping-cart-line-item-status"
    );

    this.currentItemCount = Array.from(
      this.querySelectorAll('[name="updates[]"]')
    ).reduce(
      (total, quantityInput) => total + parseInt(quantityInput.value),
      0
    );

    this.debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, 300);

    this.addEventListener("change", this.debouncedOnChange.bind(this));
  }

  onChange(event) {
    this.updateQuantity(
      event.target.closest('.cart-item').dataset.key,
      event.target.value,
      document.activeElement.getAttribute("name"),
      event.target.closest('.cart-item'),
      event.target.dataset.index,
    );
  }

  getSectionsToRender() {
    return [
      {
        id: "main-cart-items",
        section: document.getElementById("main-cart-items")?.dataset.id,
        selector: ".shopify-section",
      },
      {
        id: "cart-icon-bubble",
        section: "cart-icon-bubble",
        selector: ".shopify-section",
      },
      {
        id: "cart-live-region-text",
        section: "cart-live-region-text",
        selector: ".shopify-section",
      },
      {
        id: "main-cart-summary",
        section: document.getElementById("main-cart-summary")?.dataset.id,
        selector: ".shopify-section",
      },
      {
        id: "frequently-purchased",
        section: document.getElementById("frequently-purchased")?.dataset.id,
        selector: ".shopify-section",
      },
    ];
  }

  updateQuantity(key, quantity, name, item, line) {
    this.enableLoading(key);
    let updates;
    if(item && item.dataset.type == 'Mattress'){
      updates = this.getConnectedUpdates(quantity, item)
    }

    let body = JSON.stringify({
      id:key,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });


    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);

        // let updating = new Promise((resolve, reject) => {
        //   fetch('/cart/update.js',{
        //     method: 'POST',
        //     headers: {
        //       'Content-Type': 'application/json'
        //     },
        //     body: JSON.stringify({ updates })
        //   })
        //   .then(response => response.json())
        //   .then(data => resolve())
        //   .catch(error => {
        //     console.error(error)
        //     reject()
        //   })
        // } )
        // updating.then(() => {
          
        // })
        // this.classList.toggle("is-empty", parsedState.item_count === 0);
        // const cartFooter = document.getElementById("main-cart-summary");

        // if (cartFooter)
        //   cartFooter.classList.toggle("is-empty", parsedState.item_count === 0);
        this.getSectionsToRender().forEach((section) => {
          const elementToReplace =
            document
              .getElementById(section.id)
              .querySelector(section.selector) ||
            document.getElementById(section.id);

          elementToReplace.innerHTML = this.getSectionInnerHTML(
            parsedState.sections[section.section],
            section.selector
          );
        });

        this.updateLiveRegions(line, parsedState.item_count);
        const lineItem = document.getElementById(`.cart-item[data-key="${key}"]`);
        if (lineItem) lineItem.querySelector(`[name="${name}"]`).focus();
        //recalculateCart();
        this.disableLoading();
      })

      .catch(() => {
        this.querySelectorAll(".loading-overlay").forEach((overlay) =>
          overlay.classList.add("hidden")
        );
        document.getElementById("cart-errors").textContent =
          window.cartStrings.error;

        this.disableLoading();
      });
  }

  getConnectedUpdates(quantity, itemElement) { 
    let cartObject = JSON.parse(document.querySelector('#cartObject').textContent);
    if(!cartObject.find(item => item.handle.includes('email-product'))) return
    let updates = {}
    let totalMattressQuantity = +quantity;
    for(let item of cartObject){
      if(item.product_type == 'Mattress' && itemElement.dataset.handle !== item.handle){
        totalMattressQuantity += item.quantity
      }
    }
    let emailItems = cartObject.filter(item => item.handle.includes('email-product'))
    emailItems.forEach(item => updates[item.variant_id] = totalMattressQuantity)
    return updates
  }

  updateLiveRegions(line, itemCount) {
    if (this.currentItemCount === itemCount) {
      document
        .getElementById(`Line-item-error-${line}`)
        .querySelector(".cart-item__error-text").innerHTML =
        window.cartStrings.quantityError.replace(
          "[quantity]",
          document.getElementById(`Quantity-${line}`).value
        );
      setTimeout(() => {
        document
          .getElementById(`Line-item-error-${line}`)
          .querySelector(".cart-item__error-text").innerHTML = "";
      }, 3000);
    }

    this.currentItemCount = itemCount;
    this.lineItemStatusElement.setAttribute("aria-hidden", true);

    const cartStatus = document.getElementById("cart-live-region-text");
    cartStatus.setAttribute("aria-hidden", false);

    setTimeout(() => {
      cartStatus.setAttribute("aria-hidden", true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector).innerHTML;
  }

  enableLoading(key) {
    document
      .getElementById("main-cart-items")
      .classList.add("cart__items--disabled");
    this.querySelectorAll(`.cart-item[data-key="${key}"] .loading-overlay`).forEach(
      (overlay) => overlay.classList.remove("hidden")
    );
    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute("aria-hidden", false);
  }

  disableLoading() {
    recalculateCart();
    document
      .getElementById("main-cart-items")
      .classList.remove("cart__items--disabled");
  }
}

customElements.define("cart-items", CartItems);
